import { render, staticRenderFns } from "./footerLogo.vue?vue&type=template&id=09f37878&scoped=true&"
import script from "./footerLogo.vue?vue&type=script&lang=js&"
export * from "./footerLogo.vue?vue&type=script&lang=js&"
import style0 from "./footerLogo.vue?vue&type=style&index=0&id=09f37878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f37878",
  null
  
)

export default component.exports